export class GoldenAutumn {
    constructor(public data: {
        RateTable?: String,
        Age?: Number,
        PaymentFrequency?: Number
    }) { }
}